module.exports = __webpack_public_path__ + "img/Oficina Brasil_RJ.26f644c9.jpeg";